module.exports = __webpack_public_path__ + "static/media/bg-img-slider2.fa100723.jpg";